import { AnimatedTestimonials } from "../components/ui/animated-testimonials.tsx";

export function AnimatedTestimonialsDemo({modalDatas}) {
  
  return <AnimatedTestimonials testimonials={modalDatas} />;
}
